<template>
  <div>
    <div class="icon">
      <img src="images/headset.svg" />
    </div>
    <h1>{{ getText("headset_text") }}</h1>
    <div class="button">
      <button
        class="bg-white py-5 px-20 rounded-full"
        @click="next"
      >{{ this.getText('button_continue')}}</button>
    </div>
  </div>
</template>

<style scoped>
.icon {
  margin-left: auto;
  margin-right: auto;
  margin-top: 215px;
  width: 310px;
  height: 310px;
}

.icon img {
  width: 310px;
  height: 310px;
}

h1 {
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  text-transform: uppercase;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  width: 1000px;
}

.button {
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
</style>

<script>
export default {
  name: "Steps",
  methods: {
    getText: function(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },

    next() {
      this.$router.push("/difficulty/" + this.$route.params.lang);
    }
  }
};
</script>

